import { render, staticRenderFns } from "./MineCraft.vue?vue&type=template&id=2bdb83ea&scoped=true&"
import script from "./MineCraft.vue?vue&type=script&lang=js&"
export * from "./MineCraft.vue?vue&type=script&lang=js&"
import style1 from "./MineCraft.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb83ea",
  null
  
)

export default component.exports